function equalizeProductBars(swiperEl) {
  var bars = swiperEl.querySelectorAll('.product-showcase-slider__product-bar');
  bars.forEach(function (bar) { bar.style.height = ''; });
  var maxH = 0;
  bars.forEach(function (bar) {
    var h = bar.getBoundingClientRect().height;
    if (h > maxH) maxH = h;
  });
  if (maxH > 0) {
    bars.forEach(function (bar) { bar.style.height = maxH + 'px'; });
  }
}

function playVisibleVideos(swiperEl) {
  swiperEl.querySelectorAll('.swiper-slide video').forEach(function (video) {
    var rect = video.getBoundingClientRect();
    var visible = rect.top < window.innerHeight && rect.bottom > 0 &&
                  rect.left < window.innerWidth && rect.right > 0;
    if (visible) {
      video.play().catch(function () {});
    } else {
      video.pause();
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-showcase-slider__swiper').forEach(function (el) {
    var isNoHeading = el.closest('.product-showcase-slider__container--no-heading') !== null;

    var swiper = new Swiper(el, {
      slidesPerView: isNoHeading ? 5 : 2.8,
      spaceBetween: 8,
      grabCursor: true,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      grid: { rows: 1 },
      breakpoints: isNoHeading ? {
        0: {
          slidesPerView: 3,
          spaceBetween: 4,
          grid: { rows: 2, fill: 'row' },
        },
        768: {
          slidesPerView: 3.5,
          spaceBetween: 8,
          grid: { rows: 1 },
        },
        1025: {
          slidesPerView: 5,
          spaceBetween: 8,
          grid: { rows: 1 },
        },
      } : {
        0: {
          slidesPerView: 3,
          spaceBetween: 4,
          grid: { rows: 2, fill: 'row' },
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 8,
          grid: { rows: 1 },
        },
        1025: {
          slidesPerView: 2.8,
          spaceBetween: 8,
          grid: { rows: 1 },
        },
      },
      on: {
        init: function () {
          equalizeProductBars(el);
          playVisibleVideos(el);
        },
        slideChange: function () {
          playVisibleVideos(el);
        },
        transitionEnd: function () {
          playVisibleVideos(el);
        },
        breakpoint: function (sw) {
          sw.wrapperEl.style.height = '';
          sw.update();
          playVisibleVideos(el);
        },
      },
    });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.product-showcase-slider__swiper').forEach(function (el) {
      equalizeProductBars(el);
    });
  });

  /* Resume videos when returning to the page (tab switch, app background) */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      document.querySelectorAll('.product-showcase-slider__swiper').forEach(function (el) {
        playVisibleVideos(el);
      });
    }
  });
});

/* -----------------------------------------------------------------------
   Modal UGC — zoom + pan for image, video with native controls
   ----------------------------------------------------------------------- */
(function () {
  var modal = null;
  var mediaWrap = null;
  var hintEl = null;
  var creatorHandleEl = null;
  var currentMedia = null;
  var isVideo = false;

  var zoomLevel = 1;
  var minZoom = 1;
  var maxZoom = 5;
  var panX = 0;
  var panY = 0;

  var isDragging = false;
  var dragMoved = false;
  var dragStartX = 0;
  var dragStartY = 0;
  var dragStartPanX = 0;
  var dragStartPanY = 0;

  var isPinching = false;
  var lastPinchDist = 0;
  var pinchStartZoom = 1;

  /* -- Init modal (lazy) -- */
  function initModal() {
    if (modal) return;
    modal = document.querySelector('.pss-modal');
    if (!modal) return;
    mediaWrap = modal.querySelector('.pss-modal__media-wrap');
    hintEl = modal.querySelector('.pss-modal__hint');
    creatorHandleEl = modal.querySelector('.pss-modal__creator-handle');

    modal.querySelector('.pss-modal__close').addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (!e.target.closest('.pss-modal__container')) closeModal();
    });

    mediaWrap.addEventListener('wheel', onWheel, { passive: false });
    mediaWrap.addEventListener('click', onWrapClick);
    mediaWrap.addEventListener('dblclick', onWrapDblClick);

    mediaWrap.addEventListener('mousedown', onDragStart);
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);

    mediaWrap.addEventListener('touchstart', onTouchStart, { passive: false });
    mediaWrap.addEventListener('touchmove', onTouchMove, { passive: false });
    mediaWrap.addEventListener('touchend', onTouchEnd);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
    });
  }

  /* -- Open -- */
  function openModal(trigger) {
    initModal();
    if (!modal) return;

    var type = trigger.getAttribute('data-media-type');
    isVideo = type === 'video';

    mediaWrap.innerHTML = '';
    zoomLevel = 1;
    panX = 0;
    panY = 0;
    mediaWrap.classList.remove('pss-is-zoomed', 'pss-is-video', 'pss-no-transition');

    if (isVideo) {
      var sources = [];
      try { sources = JSON.parse(trigger.getAttribute('data-sources') || '[]'); } catch (e) {}
      var video = document.createElement('video');
      video.setAttribute('playsinline', '');
      video.setAttribute('controls', '');
      video.muted = false;
      video.autoplay = true;
      video.addEventListener('loadedmetadata', function () {
        var maxW = window.innerWidth * 0.88;
        var maxH = window.innerHeight * 0.82;
        var ratio = video.videoWidth / video.videoHeight;
        var w, h;
        if (ratio > maxW / maxH) {
          w = maxW;
          h = maxW / ratio;
        } else {
          h = maxH;
          w = maxH * ratio;
        }
        video.style.width = w + 'px';
        video.style.height = h + 'px';
      });
      sources.forEach(function (s) {
        var src = document.createElement('source');
        src.src = s.url;
        src.type = s.type;
        video.appendChild(src);
      });
      currentMedia = video;
      mediaWrap.classList.add('pss-is-video');
      if (hintEl) hintEl.style.display = 'none';
    } else {
      var img = document.createElement('img');
      img.src = trigger.getAttribute('data-src') || '';
      img.alt = trigger.getAttribute('data-alt') || '';
      img.draggable = false;
      currentMedia = img;
      if (hintEl) hintEl.style.display = '';
    }

    mediaWrap.appendChild(currentMedia);
    applyTransform(false);

    /* Creator handle overlay */
    if (creatorHandleEl) {
      var handle = trigger.getAttribute('data-creator-handle') || '';
      if (handle) {
        creatorHandleEl.textContent = '@' + handle;
        creatorHandleEl.style.display = 'block';
        /* Position over the bottom-left of the media-wrap */
        requestAnimationFrame(function () {
          var wrapRect = mediaWrap.getBoundingClientRect();
          var containerRect = modal.querySelector('.pss-modal__container').getBoundingClientRect();
          creatorHandleEl.style.bottom = (containerRect.bottom - wrapRect.bottom + 12) + 'px';
          creatorHandleEl.style.left = '12px';
        });
      } else {
        creatorHandleEl.style.display = 'none';
      }
    }

    modal.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
    document.body.style.overflow = 'hidden';

    /* Pause the inline slide video */
    var inlineVideo = trigger.querySelector('video');
    if (inlineVideo) inlineVideo.pause();
  }

  /* -- Close -- */
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    var vid = mediaWrap ? mediaWrap.querySelector('video') : null;
    if (vid) { vid.pause(); vid.src = ''; }

    setTimeout(function () {
      if (mediaWrap) mediaWrap.innerHTML = '';
      currentMedia = null;
      isVideo = false;
      zoomLevel = 1;
      panX = 0;
      panY = 0;
      /* Resume visible slider videos */
      document.querySelectorAll('.product-showcase-slider__swiper').forEach(function (el) {
        playVisibleVideos(el);
      });
    }, 320);
  }

  /* -- Transform -- */
  function applyTransform(transition) {
    if (!currentMedia || isVideo) return;
    if (transition) {
      mediaWrap.classList.remove('pss-no-transition');
    } else {
      mediaWrap.classList.add('pss-no-transition');
    }
    currentMedia.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + zoomLevel + ')';
    if (zoomLevel > 1) {
      mediaWrap.classList.add('pss-is-zoomed');
    } else {
      mediaWrap.classList.remove('pss-is-zoomed');
      panX = 0;
      panY = 0;
    }
  }

  /* -- Scroll wheel zoom -- */
  function onWheel(e) {
    if (isVideo) return;
    e.preventDefault();
    var delta = e.deltaY < 0 ? 0.25 : -0.25;
    zoomLevel = Math.max(minZoom, Math.min(maxZoom, zoomLevel + delta));
    applyTransform(false);
  }

  /* -- Click: toggle zoom -- */
  function onWrapClick(e) {
    if (isVideo || dragMoved) return;
    if (zoomLevel === 1) {
      zoomLevel = 2;
      applyTransform(true);
    } else {
      zoomLevel = 1;
      panX = 0;
      panY = 0;
      applyTransform(true);
    }
  }

  /* -- Double click: reset -- */
  function onWrapDblClick(e) {
    if (isVideo) return;
    zoomLevel = 1;
    panX = 0;
    panY = 0;
    applyTransform(true);
  }

  /* -- Drag pan (mouse) -- */
  function onDragStart(e) {
    if (isVideo || zoomLevel <= 1) return;
    isDragging = true;
    dragMoved = false;
    dragStartX = e.clientX;
    dragStartY = e.clientY;
    dragStartPanX = panX;
    dragStartPanY = panY;
    mediaWrap.classList.add('pss-is-dragging');
    e.preventDefault();
  }

  function onDragMove(e) {
    if (!isDragging) return;
    var dx = e.clientX - dragStartX;
    var dy = e.clientY - dragStartY;
    if (Math.abs(dx) > 2 || Math.abs(dy) > 2) dragMoved = true;
    panX = dragStartPanX + dx;
    panY = dragStartPanY + dy;
    applyTransform(false);
  }

  function onDragEnd() {
    if (!isDragging) return;
    isDragging = false;
    mediaWrap.classList.remove('pss-is-dragging');
    setTimeout(function () { dragMoved = false; }, 0);
  }

  /* -- Pinch + touch pan -- */
  function getTouchDist(t) {
    var dx = t[0].clientX - t[1].clientX;
    var dy = t[0].clientY - t[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function onTouchStart(e) {
    if (isVideo) return;
    if (e.touches.length === 2) {
      isPinching = true;
      lastPinchDist = getTouchDist(e.touches);
      pinchStartZoom = zoomLevel;
      e.preventDefault();
    } else if (e.touches.length === 1 && zoomLevel > 1) {
      isDragging = true;
      dragMoved = false;
      dragStartX = e.touches[0].clientX;
      dragStartY = e.touches[0].clientY;
      dragStartPanX = panX;
      dragStartPanY = panY;
    }
  }

  function onTouchMove(e) {
    if (isVideo) return;
    if (e.touches.length === 2 && isPinching) {
      e.preventDefault();
      var dist = getTouchDist(e.touches);
      var ratio = dist / lastPinchDist;
      zoomLevel = Math.max(minZoom, Math.min(maxZoom, zoomLevel * ratio));
      lastPinchDist = dist;
      applyTransform(false);
    } else if (e.touches.length === 1 && isDragging) {
      e.preventDefault();
      var dx = e.touches[0].clientX - dragStartX;
      var dy = e.touches[0].clientY - dragStartY;
      if (Math.abs(dx) > 2 || Math.abs(dy) > 2) dragMoved = true;
      panX = dragStartPanX + dx;
      panY = dragStartPanY + dy;
      applyTransform(false);
    }
  }

  function onTouchEnd() {
    isPinching = false;
    isDragging = false;
    setTimeout(function () { dragMoved = false; }, 0);
  }

  /* -- Bind triggers -- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pss-open]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();
      openModal(trigger);
    }
  });
})();
